/* eslint-disable no-unused-expressions */

import React, { Fragment, useState } from 'react';
import './style.scss';
import { Image, Link, RichText } from '@sitecore-jss/sitecore-jss-react';
import clsx from 'clsx';
import GenericPlaceholder from '../Shared/components/GenericPlaceholder/index.js';

const FooterComponent = (props) => {
  const {
    copyrightLinks: CopyrightLinks,
    logo: Logo,
    title: Title,
    socialLinks: SocialLinks,
    topLinks: TopLinks,
    appLinks: AppLinks,
    appLinks2: AppLinks2,
    qrCode,
    qrCode2,
    items,
    arrowWhite,
    appLinksTitle,
    appLinks2Title,
  } = props?.fields;

  const { params } = props;
  const [selectedIndex, setSelectedIndex] = useState(-1);

  //item in the links that we are looping on
  const LinkItem = (obj) => {
    let hasChildren = false;
    const shouldRenderSubChildren = obj.item?.fields?.items?.length > 0;

    obj.item?.fields?.items?.map((link) => {
      if (!!link && !!link?.fields?.link?.value?.href) {
        hasChildren = !!link && !!link?.fields?.link?.value?.href;
      }
    });
    if (!props?.fields || !props.params)
      return <GenericPlaceholder componentName="FooterComponent" />;
    return (
      <div
        className={clsx(
          'column column-responsive',
          selectedIndex === obj.index && hasChildren ? 'active' : ''
        )}
      >
        <div
          className="main-title"
          onClick={() => {
            if (selectedIndex === obj.index) {
              setSelectedIndex(-1);
            } else {
              setSelectedIndex(obj.index);
            }
          }}
        >
          <RichText className="main-title-text" field={obj.item?.fields?.title} />
          {shouldRenderSubChildren && (
            <div className="arrow mobile">
              <Image className="icon-angle-down default" field={arrowWhite} />
            </div>
          )}
        </div>

        {shouldRenderSubChildren && (
          <div className="link-content">
            {obj.item?.fields?.items?.map((link, index) => {
              const shouldRenderLink = !!link && !!link?.fields?.link?.value?.href;

              return (
                shouldRenderLink && (
                  <Fragment key={index}>
                    <Link
                      field={link?.fields?.link}
                      className={`link-item ${
                        link?.fields?.specialLink?.value === true ? 'isLink' : ''
                      }`}
                    ></Link>
                  </Fragment>
                )
              );
            })}
          </div>
        )}
      </div>
    );
  };

  //render conditions
  const shouldRenderTopLinks = !!TopLinks && TopLinks.length > 0;
  const shouldRenderCopyrightLinks = !!CopyrightLinks && CopyrightLinks.length > 0;
  const shouldRenderSocialLinks = !!SocialLinks && SocialLinks.length > 0;
  const shouldRenderItems = !!items && items.length > 0;
  const weHaveTwoApps = !!AppLinks && AppLinks.length > 0 && !!AppLinks2 && AppLinks2.length > 0;

  const AppLinksComponent = ({ AppLinks, withTag, title, qrCode }) => {
    const shouldRenderAppLinks = !!AppLinks && AppLinks.length > 0;
    if (!shouldRenderAppLinks) {
      return null;
    }
    return (
      <div className="apps flex-it flex-align-item-center">
        {!!qrCode && (
          <div className="qrCodes-item">
            {qrCode?.map((item, index) => {
              return (
                <div className="qrCode-item" key={index}>
                  <figure>
                    <Image field={item?.fields?.linkIcon} />
                  </figure>
                </div>
              );
            })}
          </div>
        )}
        <div className="app-text-image">
          <RichText className="app-title" field={title} />
          <div className="app-links-wrap flex-it flex-align-item-center">
            {AppLinks?.map((item, index) => {
              const shouldRenderImage = !!item?.fields?.linkIcon?.value;
              const shouldRenderTag = withTag || item?.fields?.linkType?.value !== 'qrcode';
              return (
                shouldRenderTag && (
                  <a className={`app-link`} key={index} href={item?.fields?.link?.value?.href}>
                    {shouldRenderImage && (
                      <figure>
                        <Image field={item?.fields?.linkIcon} />
                      </figure>
                    )}
                  </a>
                )
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  //returned data
  const isEliteTheme = props?.fields?.IsEliteTheme?.value;
  return (
    <footer
      className={clsx(
        'footer',
        isEliteTheme ? 'theme-elite' : 'theme-default',
        'add-margins',
        params?.Styles
      )}
    >
      <div className="app-part flex-it flex-align-item-center">
        <div className="wrap">
          <div
            className={clsx('auto flex-it flex-justify-between', weHaveTwoApps ? 'twoApps' : '')}
          >
            <RichText
              className="text footer-text-wrap flex-it flex-align-item-center"
              field={Title}
            />

            <div className="app-wrap-items flex-it flex-align-item-center flex-align-start">
              {AppLinks && (
                <AppLinksComponent
                  AppLinks={AppLinks}
                  withTag={true}
                  title={appLinksTitle}
                  qrCode={qrCode}
                />
              )}
              {AppLinks2 && (
                <AppLinksComponent
                  AppLinks={AppLinks2}
                  withTag={true}
                  title={appLinks2Title}
                  qrCode={qrCode2}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="apply-link-part flex-it flex-align-item-center">
        <div className="wrap flex-it">
          <div className="left-space"></div>
          <div className="columns flex-it flex-wrap">
            {shouldRenderTopLinks &&
              TopLinks?.map((item, index) => {
                return (
                  <div className="column column-responsive" key={index}>
                    <Link className="link" field={item?.fields?.link}>
                      <span className="icon">
                        <Image field={item?.fields?.linkIcon} />
                      </span>
                      <span className="text">{item?.fields?.link?.value?.text}</span>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
      <div className={`link-logo-part ${selectedIndex !== -1 ? 'atLeastOneActive' : ''}`}>
        <div className={clsx('wrap flex-it flex-wrap', weHaveTwoApps ? 'twoApps' : '')}>
          <div className="columns flex-it flex-wrap">
            {shouldRenderItems &&
              items?.map((item, index) => {
                const shouldRenderLinks = !!item?.fields?.items && item?.fields?.items?.length > 0;
                if (!shouldRenderLinks) {
                  return null;
                }
                return <LinkItem item={item} key={index} index={index} />;
              })}
          </div>

          <div className="mobile mobileCss">
            <div className="app-wrap-items flex-it flex-align-start">
              {AppLinks && (
                <AppLinksComponent
                  AppLinks={AppLinks}
                  withTag={false}
                  title={appLinksTitle}
                  qrCode={qrCode}
                />
              )}
              {AppLinks2 && (
                <AppLinksComponent
                  AppLinks={AppLinks2}
                  withTag={false}
                  title={appLinks2Title}
                  qrCode={qrCode2}
                />
              )}
            </div>
          </div>

          <div className="logo-socials">
            <div className="logo">
              <Image field={Logo} />
            </div>
            {shouldRenderSocialLinks && (
              <div className="socials">
                {SocialLinks?.map((item, index) => {
                  return (
                    <Link className="social" field={item?.fields?.link} key={index}>
                      <Image field={item?.fields?.linkIcon} />
                    </Link>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </div>

      <div className={`copyright flex-it flex-align-item-center`}>
        <div className="wrap flex-it flex-align-item-center flex-justify-center">
          {shouldRenderCopyrightLinks &&
            CopyrightLinks?.map((item, index) => {
              return (
                <Fragment key={index}>
                  <Link
                    className={clsx('link', !!!item?.fields?.link?.value?.href && 'not-clickable')}
                    field={item?.fields?.link}
                  />
                  <span className="sep"></span>
                </Fragment>
              );
            })}
        </div>
      </div>
    </footer>
  );
};
export default FooterComponent;
